// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"234e5d41","455":"7c5a6dc9","551":"3c389f78","977":"ec71c49a"}[chunkId] + ".chunk.js";
};